import { computed, inject, InjectionToken } from '@angular/core';
import {
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import {
  clearStorage,
  getItem,
  removeItem,
  setItem,
} from './local-storage.methods';
import { LOCAL_STORAGE_INITIAL_STATE } from '../constants/local-storage.constants';


// InjectionToken for providing the initial state
const LOCAL_STORAGE_STATE = new InjectionToken<Record<string, any>>(
  'LocalStorageState',
  { factory: () => LOCAL_STORAGE_INITIAL_STATE }
);

// Definition of the LocalStorageStore
export const LocalStorageStore = signalStore(
  { providedIn: 'root' },
  withState(() => inject(LOCAL_STORAGE_STATE)),
  withComputed((state) => ({
    // Computed property to get all keys in the store
    keys: computed<any[]>(() => Object.keys(state)),
  })),
  withMethods((store) => ({
    getItem: <T>(key: string) => getItem<T>(store, key),
    setItem: <T>(key: string, value: T) => setItem(store, key, value),
    removeItem: (key: string) => removeItem(store, key),
    clear: () => clearStorage(store),
  })),
  withHooks({
    onInit(store) {
      // Load all keys from localStorage into the store state on initialization
      Object.keys(localStorage).forEach((key) => {
        getItem(store, key);
      });
    },
  })
);
